if (process.env.NODE_ENV === 'production') {
  module.exports = require('./modal.production.js');
} else {
  module.exports = require('./modal.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/modal/dist/es/modal.js
// module id = 1406
// module chunks = 0